/* istanbul ignore file */
import { number as codecNumber, string as codecString } from 'purify-ts/Codec';
import { utils as coreUtils } from '@codegrade/api-core';
import { parsers } from '@codegrade/utils';
import { GitUserInfo } from './GitUserInfo';
import { OAuthProvider } from './OAuthProvider';
const OAuthTokenParser = /* #__PURE__ */ parsers.object([
    ['id', codecString],
    ['provider', OAuthProvider],
    ['userId', codecNumber, 'user_id'],
    ['userInfo', /* #__PURE__ */ parsers.maybeNull(GitUserInfo), 'user_info'],
]);
export class OAuthToken extends /* #__PURE__ */ coreUtils.AssigningBase {
    static decode(input) {
        return OAuthTokenParser.decode(input).map(res => new OAuthToken(res));
    }
    static unsafeDecode(input) {
        return OAuthToken.decode(input).unsafeCoerce();
    }
    static encode(data) {
        return OAuthTokenParser.encode(data);
    }
    static schema() {
        return OAuthTokenParser.schema();
    }
}
